import { testKitsApi } from './index'

export default testKitsApi.middleware
